import Endpoint from "@/utils/endPoint";

const kinsfolkEndpoint = new Endpoint("/kinsfolk/{kinsfolkId}");
const relationshipEndpoint = new Endpoint("/kinsfolk/relationship_types");

class KinsfolkService {
    async getRelationShipListService(params) {
        const result = await relationshipEndpoint.get(params);
        return result;
    }

    async updateKinsfolkService(params) {
        const result = await kinsfolkEndpoint.put(params);
        return result;
    }

    async delKinsfolkService(params) {
        const result = await kinsfolkEndpoint.del(null, params);
        return result;
    }
}

export default new KinsfolkService();
